import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

let Amenities: any = [[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[866.009,587.2]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[888.152,790.749]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[971.506,609.021]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1003.34,575.192]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1003.85,615.926]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1105.87,607.794]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1112.89,581.237]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1117.69,657.25]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1137.98,601.377]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1149.73,707.409]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1138.85,733.242]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1144.85,705.582]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1157.75,647.623]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1185.68,591.935]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1216.5,694.489]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1320.35,651.125]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[856.175,787.112]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[863.95,585.049]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[957.077,608.407]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[985.751,615.848]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1004.73,575.216]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1091.88,609.501]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1104.71,659.518]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1112.41,582.957]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1127.55,603.608]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1124.8,736.599]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1138.45,710.979]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1140.31,708.906]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1149.33,650.645]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1180.86,594.914]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1211.95,699.333]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1335.52,658.082]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[826.053,782.614]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[862.973,582.88]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[943.072,607.536]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[967.781,615.434]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1006.11,575.252]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1076.93,610.955]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1090.63,661.506]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1111.1,584.679]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1109.39,739.584]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1115.89,605.662]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1125.72,714.323]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1134.54,712.11]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1139.5,653.501]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1174.49,597.847]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1205.56,704.094]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1349.16,665.963]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[798.158,777.325]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[863.076,580.709]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[929.648,606.416]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[950.156,614.689]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1007.49,575.305]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1061.18,612.136]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1075.61,663.183]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1092.76,742.145]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1103.1,607.519]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1111.58,717.4]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1108.96,586.399]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1128.35,656.157]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1127.61,715.152]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1166.59,600.717]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1197.36,708.726]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1360.78,674.914]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[772.776,771.36]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[864.237,578.558]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[916.944,605.068]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[933.078,613.63]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1008.88,575.386]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1044.8,613.04]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1059.81,664.538]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1075.1,744.257]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1089.31,609.17]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1096.09,720.179]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1106.03,588.126]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1115.99,658.602]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1119.58,718.015]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1157.22,603.52]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1187.44,713.215]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1369.74,684.786]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[750.129,764.828]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[866.437,576.447]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[905.09,603.516]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[916.738,612.28]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1010.31,575.514]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1028,613.667]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1043.42,665.567]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1056.62,745.896]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1074.66,610.612]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1079.26,722.604]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1102.34,589.88]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1102.56,660.831]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1110.58,720.687]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1146.44,606.263]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1175.91,717.574]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1375.57,695.143]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[730.393,757.818]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[869.665,574.398]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[894.212,601.781]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[901.321,610.658]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1010.96,614.018]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1011.8,575.718]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1026.63,666.263]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1037.55,747.027]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1059.33,611.848]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1061.06,724.535]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1088.2,662.844]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1097.92,591.694]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1100.76,723.17]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1134.31,608.952]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1162.92,721.86]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1378.09,705.59]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[713.653,750.451]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[873.898,572.442]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[884.415,599.899]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[886.986,608.802]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[993.886,614.118]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1009.68,666.651]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1013.36,576.051]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1018.15,747.657]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1043.48,612.9]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1041.48,725.68]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1073.09,664.681]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1092.82,593.619]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1090.32,725.544]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1120.94,611.612]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1148.62,726.235]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1377.31,715.963]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[700.001,742.79]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[873.902,606.74]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[875.81,597.902]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[879.133,570.62]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[976.993,613.984]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[992.766,666.746]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[998.707,747.765]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1014.99,576.578]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1027.28,613.787]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1020.71,725.435]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1057.39,666.378]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1079.47,727.965]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1086.99,595.698]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1106.35,614.243]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1132.96,730.866]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1373.12,726.195]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[689.466,734.917]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[862.213,604.517]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[868.494,595.837]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[885.354,568.991]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[960.478,613.653]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[976.118,666.602]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[979.569,747.391]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1010.9,614.541]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[999.723,723.363]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1016.65,577.379]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1041.21,667.997]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1068.26,730.742]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1080.4,597.946]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1090.63,616.822]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1115.71,735.786]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1365.4,736.247]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[682.008,726.934]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[852.029,602.203]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[862.527,593.778]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[892.508,567.644]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[944.518,613.187]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[959.926,666.315]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[961.086,746.687]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[994.465,615.199]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[979.805,720.156]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1018.22,578.512]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1024.65,669.599]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1056.4,734.135]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1073.84,619.301]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1072.98,600.329]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1096.62,740.686]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1354.04,746.085]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[677.566,718.93]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[843.422,599.88]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[857.935,591.812]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[900.495,566.681]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[929.245,612.643]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[944.313,665.989]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[943.548,745.941]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[961.191,716.931]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[978.102,615.778]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1007.74,671.169]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1019.55,579.954]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1043.32,737.851]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1056.09,621.587]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1064.69,602.738]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1075.75,745.044]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1338.95,755.644]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[676.024,711.016]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[836.396,597.648]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[854.67,590.036]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[909.125,566.177]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[914.736,612.072]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[926.948,745.565]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[929.302,665.707]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[943.489,714.069]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[961.897,616.262]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[990.501,672.606]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1020.49,581.592]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1028.92,741.187]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1037.56,623.586]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1053.51,748.529]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1055.56,605.042]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1320.13,764.872]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[677.326,703.276]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[830.916,595.582]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[852.645,588.512]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[901.043,611.46]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[910.865,745.64]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[914.874,665.425]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[918.166,566.11]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[926.49,711.416]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[945.952,616.578]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[973.057,673.718]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1013.62,743.661]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1018.46,625.194]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1020.98,583.258]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1030.38,751.02]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1045.7,607.109]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1297.56,773.652]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[681.382,695.855]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[826.868,593.723]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[851.7,587.244]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[888.205,610.763]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[894.908,745.668]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[901.028,665.014]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[910.199,708.802]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[930.399,616.645]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[927.406,566.342]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[955.624,674.359]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[997.898,745.232]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[999.026,626.353]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1006.81,752.568]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1021.07,584.818]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1035.24,608.87]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1271.32,781.891]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[688.135,688.952]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[824.142,592.029]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[851.714,586.144]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[876.307,609.889]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[879.282,744.981]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[887.881,664.289]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[894.736,706.08]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[915.419,616.377]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[938.481,674.43]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[936.761,566.689]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[979.535,627.016]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[982.133,745.983]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[983.159,753.216]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1020.84,586.199]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1024.36,610.281]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1241.55,789.427]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[697.343,682.891]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[822.637,590.411]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[852.606,585.087]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[864.492,743.365]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[865.454,608.771]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[875.615,663.142]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[880.239,703.188]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[901.198,615.737]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[921.901,673.923]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[946.233,567.022]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[960.25,627.184]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[959.763,753.041]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[966.58,746.039]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1013.21,611.344]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1020.35,587.39]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1208.49,796.135]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[708.443,677.923]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[822.316,588.767]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[850.953,740.91]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[854.372,583.968]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[855.77,607.371]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[864.43,661.546]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[866.845,700.099]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[887.925,614.719]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[906.127,672.873]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[936.923,752.104]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[941.423,626.87]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[951.44,745.495]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[955.86,567.295]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1001.94,612.071]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1019.68,588.404]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1172.49,801.884]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[720.7,673.828]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[823.191,587.028]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[838.924,737.78]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[847.376,605.684]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[854.501,659.524]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[857.046,582.737]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[854.684,696.799]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[875.765,613.339]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[891.367,671.324]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[914.922,750.453]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[923.291,626.095]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[936.884,744.411]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[965.665,567.516]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[990.673,612.476]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1018.86,589.264]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1133.97,806.537]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[733.761,670.025]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[825.271,585.177]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[828.54,734.143]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[840.356,603.741]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[845.946,657.144]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[860.647,581.393]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[843.854,693.307]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[864.849,611.639]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[877.783,669.344]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[894.01,748.156]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[906.066,624.896]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[923.061,742.857]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[975.642,567.716]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[979.551,612.584]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1017.91,589.996]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1093.47,810.006]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[747.727,666.159]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[819.864,730.139]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[828.549,583.232]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[834.762,601.584]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[838.834,654.48]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[834.426,689.655]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[855.27,609.666]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[865.499,667]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[865.171,579.967]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[874.408,745.287]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[889.928,623.319]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[910.099,740.895]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[968.688,612.419]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[985.762,567.933]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1016.87,590.622]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1051.6,812.238]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[762.757,662.219]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[812.933,725.865]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[830.626,599.258]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[833.007,581.227]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[833.212,651.594]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[826.462,685.866]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[847.103,607.465]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[854.62,664.346]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[856.311,741.901]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[870.601,578.496]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[875.041,621.4]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[898.114,738.567]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[958.194,612.001]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[995.985,568.194]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1009,813.176]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1015.75,591.158]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[778.862,658.327]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[807.732,721.42]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[827.94,596.812]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[829.08,648.556]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[819.982,681.981]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[838.591,579.205]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[840.38,605.085]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[839.866,738.081]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[845.206,661.447]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[861.525,619.188]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[876.89,577.018]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[887.194,735.935]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[948.167,611.356]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[966.327,812.839]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1006.26,568.527]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1014.55,591.62]]
    },],[{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[795.98,654.601]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[804.233,716.881]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[826.68,594.291]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[826.423,645.422]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[825.191,733.9]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[814.994,678.038]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[835.117,602.573]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[837.298,658.358]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[845.241,577.202]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[849.478,616.728]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[877.414,733.049]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[883.985,575.567]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[924.24,811.26]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[938.695,610.506]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1013.29,592.021]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1016.54,568.948]]
    },],[{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[802.402,712.301]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[812.381,729.412]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[814.02,651.122]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[825.22,642.234]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[826.818,591.73]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[811.501,674.063]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[831.32,599.961]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[830.923,655.12]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[838.981,614.056]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[852.896,575.249]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[868.837,729.945]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[883.363,808.475]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[891.834,574.171]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[929.86,609.469]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1011.98,592.367]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1026.76,569.473]]
    },],[{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[801.482,724.697]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[802.174,707.743]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[825.418,639.039]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[826.077,651.786]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[809.471,670.095]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[828.298,589.164]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[828.964,597.291]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[830.076,611.217]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[832.868,647.948]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[844.26,804.587]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[861.476,573.377]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[861.499,726.679]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[900.37,572.854]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[921.728,608.269]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1010.63,592.666]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1036.88,570.11]]
    },],[{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[792.55,719.788]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[803.508,703.231]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[807.458,799.647]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[822.813,608.236]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[822.767,648.379]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[808.896,666.147]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[828.037,594.586]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[826.989,635.86]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[831.084,586.618]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[852.435,645.11]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[855.444,723.265]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[870.922,571.603]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[909.542,571.632]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[914.37,606.914]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1009.24,592.918]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1046.83,570.866]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[773.403,793.749]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[785.605,714.732]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[806.343,698.796]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[817.217,605.144]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[820.982,644.93]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[809.745,662.238]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[828.514,591.871]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[829.883,632.724]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[835.124,584.114]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[850.697,719.731]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[872.622,642.627]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[881.162,569.948]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[907.845,605.419]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[919.287,570.52]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1007.83,593.122]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1056.55,571.744]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[742.408,787.044]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[780.624,709.594]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[813.274,601.977]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[810.593,694.481]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[820.675,641.477]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[811.958,658.4]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[830.336,589.176]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[834.028,629.661]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[840.342,581.678]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[847.257,716.121]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[892.114,568.427]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[893.325,640.52]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[902.195,603.806]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[929.534,569.531]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1006.41,593.283]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1065.97,572.746]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[714.665,779.67]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[777.565,704.43]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[810.959,598.769]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[816.17,690.316]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[821.797,638.054]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[815.475,654.659]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[833.444,586.525]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[839.352,626.698]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[846.664,579.33]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[845.109,712.474]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[897.453,602.093]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[903.698,567.053]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[914.447,638.798]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[940.217,568.675]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1004.98,593.402]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1075.05,573.872]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[690.156,771.78]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[776.342,699.308]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[810.21,595.554]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[824.267,634.7]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[822.966,686.345]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[820.207,651.048]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[837.755,583.942]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[845.762,623.864]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[844.211,708.845]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[853.997,577.089]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[893.629,600.308]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[915.828,565.837]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[935.894,637.475]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[951.263,567.962]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1003.56,593.489]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1083.72,575.124]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[668.734,763.361]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[776.895,694.263]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[810.983,592.352]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[828.03,631.432]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[830.902,682.583]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[826.097,647.578]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[843.208,581.442]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[844.536,705.256]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[853.19,621.172]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[862.274,574.969]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[890.739,598.461]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[928.435,564.786]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[957.591,636.552]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[962.611,567.397]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1002.16,593.542]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1091.93,576.498]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[650.079,754.128]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[779.123,689.344]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[813.207,589.188]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[833.005,628.278]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[839.879,679.056]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[833.061,644.272]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[846.03,701.745]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[849.722,579.043]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[861.551,618.641]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[871.41,572.981]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[888.782,596.573]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[941.445,563.908]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[974.197,566.986]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[979.46,636.037]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1000.79,593.565]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1099.62,577.993]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[634.423,743.231]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[782.959,684.569]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[816.833,586.07]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[839.136,625.247]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[848.659,698.323]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[849.823,675.768]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[841.047,641.132]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[857.241,576.752]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[870.784,616.278]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[881.343,571.133]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[887.765,594.65]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[954.793,563.206]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[985.961,566.731]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[999.464,593.554]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1001.43,635.928]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1106.73,579.602]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[623.347,730.555]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[788.297,679.975]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[821.784,583.014]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[846.344,622.355]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[852.363,695.016]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[849.977,638.17]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[860.645,672.734]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[865.687,574.58]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[880.808,614.094]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[887.677,592.703]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[891.995,569.433]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[968.406,562.685]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[998.185,593.509]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[997.84,566.636]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1023.43,636.229]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1113.2,581.318]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[617.721,717.989]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[795.032,675.589]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[827.984,580.027]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[854.555,619.617]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[857.08,691.847]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[859.785,635.396]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[874.985,572.536]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[872.256,669.967]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[888.503,590.743]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[891.547,612.098]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[903.291,567.888]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[982.216,562.348]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[996.968,593.428]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1009.77,566.703]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1045.37,636.941]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1118.97,583.134]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[616.453,706.695]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[803.058,671.435]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[835.357,577.11]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[863.694,617.04]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[862.746,688.83]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[870.406,632.813]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[885.066,570.624]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[884.576,667.471]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[890.226,588.77]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[902.93,610.295]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[915.159,566.502]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[995.822,593.31]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[996.149,562.197]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1021.68,566.931]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1067.18,638.066]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1123.98,585.039]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[618.519,696.544]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[812.245,667.545]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[843.811,574.26]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[869.279,685.99]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[873.678,614.635]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[892.817,586.787]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[881.774,630.43]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[895.847,568.85]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[897.511,665.259]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[914.875,608.694]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[927.522,565.279]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[994.76,593.151]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1010.14,562.234]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1033.51,567.322]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1088.77,639.606]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1128.17,587.023]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[623.407,687.235]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[822.442,663.951]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[853.244,571.464]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[876.586,683.352]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[884.423,612.411]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[896.238,584.785]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[893.827,628.254]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[907.248,567.212]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[910.972,663.344]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[927.303,607.302]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[940.302,564.222]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[993.792,592.953]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1024.1,562.458]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1045.19,567.874]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1110.06,641.565]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1131.51,589.074]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[630.836,678.576]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[833.482,660.678]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[863.562,568.696]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[884.574,680.928]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[895.857,610.366]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[900.458,582.738]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[906.529,626.291]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[919.198,565.709]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[924.875,661.73]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[940.144,606.12]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[953.428,563.328]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[992.93,592.707]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1037.98,562.869]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1056.66,568.585]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1133.94,591.18]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1130.96,643.944]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[640.547,670.485]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[845.108,657.749]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[874.638,565.918]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[893.12,678.737]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[905.428,580.594]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[907.898,608.5]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[919.857,624.557]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[931.615,564.331]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[939.133,660.43]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[953.321,605.152]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[966.828,562.595]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[992.188,592.407]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1051.7,563.465]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1067.85,569.452]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1135.43,593.329]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1151.39,646.749]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[652.315,662.921]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[856.9,655.107]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[886.327,563.085]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[902.081,676.781]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[911.086,578.248]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[920.478,606.802]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[933.835,623.092]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[944.428,563.065]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[953.66,659.452]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[966.766,604.399]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[980.434,562.017]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[991.582,592.033]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1065.2,564.243]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1078.71,570.471]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1135.95,595.508]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1171.26,649.984]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[665.949,655.857]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[868.159,652.26]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[898.445,560.171]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[917.309,575.5]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[911.274,675.014]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[933.54,605.239]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[948.534,621.999]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[957.564,561.885]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[968.374,658.798]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[980.416,603.857]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[991.136,591.545]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[994.181,561.584]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1078.41,565.199]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1089.17,571.636]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1135.47,597.698]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1190.47,653.649]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[681.239,649.286]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[878.976,647.595]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[910.76,557.229]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[923.748,572.056]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[920.461,673.305]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[947.029,603.747]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[964.021,621.543]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[970.942,560.757]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[983.184,658.481]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[990.884,590.857]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[994.208,603.522]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1008,561.28]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1091.27,566.327]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1099.17,572.939]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1133.99,599.886]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1208.91,657.753]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[698.038,643.19]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[892.269,641.564]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[923.107,554.469]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[929.638,567.927]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[929.473,671.286]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[960.907,602.167]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[984.472,559.63]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[980.104,622.165]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[990.875,589.739]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[997.993,658.493]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1008.08,603.376]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1021.84,561.081]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1103.69,567.62]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1108.65,574.369]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1131.46,602.044]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1226.47,662.287]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[716.19,637.563]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[907.957,637.138]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[934.574,564.352]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[935.508,552.195]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[938.583,668.462]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[975.075,600.088]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[991.084,587.516]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[998.028,558.439]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[995.999,624.016]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1012.68,658.832]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1021.99,603.391]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1035.6,560.952]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1115.6,569.063]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1117.54,575.907]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1127.9,604.139]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1242.98,667.245]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[735.523,632.403]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[924.41,634.275]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[939.836,562.418]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[948.167,550.581]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[948.652,664.982]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[990.213,582.357]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[988.874,596.494]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1011.43,557.13]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1010.97,626.401]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1027.09,659.484]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1035.86,603.514]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1049.21,560.837]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1123.31,606.137]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1125.76,577.53]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1126.93,570.64]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1258.33,672.624]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[755.888,627.707]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[946.328,561.53]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[941.133,632.342]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[961.258,549.578]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[960.021,661.815]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[984.499,577.103]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[999.685,591.694]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1024.42,555.722]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1025.13,628.598]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1041.03,660.395]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1049.69,603.621]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1062.55,560.657]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1117.74,607.981]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1133.28,579.2]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1137.61,572.322]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1272.35,678.416]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[777.124,623.477]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[953.858,561.035]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[957.995,631.032]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[974.8,549.032]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[972.2,659.521]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[980.465,576.658]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1009.44,590.393]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1038.83,630.496]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1036.8,554.419]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1054.23,661.403]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1063.43,603.359]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1075.46,560.313]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1111.32,609.547]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1140.05,580.856]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1147.57,574.069]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1284.91,684.626]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[799.126,619.701]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[962.081,560.701]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[979.035,576.902]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[974.938,630.199]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[988.709,548.818]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[984.708,658.042]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1021.31,590.951]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1052.25,632.235]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1048.58,553.581]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1076.73,601.522]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1066.51,662.094]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1087.68,559.741]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1104.34,610.266]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1146.02,582.374]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1156.76,575.808]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1295.84,691.237]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[821.774,616.376]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[970.757,560.469]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[978.605,577.022]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[991.905,629.779]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1002.86,548.859]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[997.298,657.202]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1034.18,591.816]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1060.01,553.44]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1065.43,633.961]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1086.08,596.889]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1078.24,661.972]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1095.6,602.405]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1098.88,559.07]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1151.14,583.486]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1165.08,577.405]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1304.97,698.243]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[844.986,613.492]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[978.641,577.024]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[979.733,560.333]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1008.84,629.73]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1009.84,656.854]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1017.15,549.118]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1047.32,592.811]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1071.33,553.943]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1078.32,635.764]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1073.49,599.699]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1092.92,596.785]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1090.32,661.329]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1108.91,558.74]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1155.12,583.543]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1172.4,578.59]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1312.07,705.606]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[868.664,611.045]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[978.955,576.954]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[988.896,560.297]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1022.26,656.91]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1031.44,549.576]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1025.67,630.031]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1060.41,593.952]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1061.93,601.777]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1082.58,554.908]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1090.87,637.702]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1102.45,598.92]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1102.95,661.176]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1118.08,559.189]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1156.58,581.585]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1178.32,578.87]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1316.92,713.294]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[892.722,609.029]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[979.467,576.841]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[998.157,560.367]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1034.49,657.315]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1045.65,550.224]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1042.33,630.669]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1050.7,603.151]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1073.28,595.259]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1093.67,556.185]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1102.98,639.808]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1112.64,601.188]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1115.57,661.931]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1126.79,560.425]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1153.63,580.042]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1181.68,577.947]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1319.26,721.251]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[917.08,607.441]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[980.136,576.702]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1007.44,560.548]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1039.12,604.17]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1046.45,658.028]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1059.68,551.059]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1058.75,631.63]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1085.8,596.744]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1104.44,557.689]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1114.58,642.096]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1122.6,603.511]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1135.15,562.192]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1127.72,663.476]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1150.16,581.766]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1181.69,577.621]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1318.78,729.378]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[941.654,606.276]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[980.937,576.548]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1016.68,560.844]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1027.16,604.92]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1058.09,659.026]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1073.43,552.077]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1074.85,632.908]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1097.87,598.414]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1114.77,559.373]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1125.59,644.576]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1132,605.931]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1143.04,564.275]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1139.15,665.624]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1147.4,584.464]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1180.55,579.515]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1315.17,737.507]]
    },],[{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[966.367,605.533]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[981.851,576.389]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1014.89,605.428]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1025.8,561.256]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1069.33,660.295]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1086.82,553.276]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1090.55,634.5]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1109.4,600.271]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1124.54,561.214]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1135.93,647.255]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1140.68,608.473]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1144.37,587.185]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1150.31,566.555]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1149.73,668.242]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1179.36,582.444]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1308.08,745.304]]
    },],[{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[982.865,576.229]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[991.144,605.208]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[1002.42,605.7]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1034.76,561.786]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1080.13,661.816]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1099.77,554.653]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1105.76,636.396]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1120.3,602.313]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1133.64,563.196]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1145.52,650.128]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1140.52,589.797]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1148.5,611.144]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1156.78,568.974]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1159.36,671.235]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1177.61,585.575]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1297.39,752.173]]
    },],[{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[983.965,576.075]]
    },{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[989.857,605.747]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1015.92,605.3]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1043.48,562.432]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1090.4,663.583]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1112.19,556.205]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1120.43,638.595]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1130.5,604.538]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1135.64,592.294]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1141.97,565.31]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1154.28,653.196]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1155.38,613.945]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1162.34,571.502]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1167.94,674.549]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1174.86,588.693]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1283.68,757.661]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[977.333,605.574]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[985.141,575.93]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1040.62,605.809]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1051.92,563.194]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1100.1,665.587]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1124.01,557.928]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1129.67,594.678]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1134.46,641.093]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1139.92,606.942]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1149.46,567.549]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1162.14,656.455]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1161.24,616.874]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1166.88,574.121]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1170.88,591.748]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1175.41,678.144]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1267.92,762.221]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[964.964,605.184]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[986.384,575.797]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1060.03,564.068]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1065.19,606.733]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1109.16,667.813]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1122.56,596.94]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1135.15,559.818]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1148.48,609.515]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1147.76,643.881]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1156.01,569.902]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1169.01,659.892]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1165.54,594.719]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1165.99,619.916]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1170.3,576.816]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1181.67,681.98]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1250.27,766.751]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[952.867,604.589]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[987.682,575.677]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1067.75,565.053]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1089.55,608.075]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1114.33,599.074]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1117.51,670.256]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1145.54,561.869]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1156.1,612.252]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1158.78,597.595]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1161.55,572.36]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1160.27,646.956]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1174.83,663.502]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1172.54,579.574]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1169.58,623.065]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1186.66,686.032]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1230.33,771.582]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[941.162,603.785]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[989.029,575.57]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1075.02,566.143]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1105,601.056]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1113.65,609.835]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1125.09,672.892]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1150.58,600.349]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1155.07,564.076]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1162.71,615.135]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1166,574.91]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1179.5,667.259]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1173.49,582.376]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1171.91,626.293]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1171.86,650.301]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1190.27,690.254]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1207.78,776.504]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[929.97,602.777]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[990.415,575.473]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1081.79,567.331]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1094.62,602.862]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1131.81,675.697]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1137.38,612.012]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1140.93,602.952]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1163.64,566.427]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1169.26,577.534]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1168.19,618.144]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1173.1,585.198]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1182.93,671.133]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1172.91,629.574]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1182.44,653.897]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1182.57,781.22]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1192.42,694.601]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[919.395,601.579]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[991.832,575.388]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1083.26,604.478]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1088.01,568.612]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1129.88,605.381]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1137.61,678.657]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1154.87,785.506]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1160.67,614.608]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1171.19,568.914]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1171.27,580.217]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1171.3,588.02]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1172.49,621.264]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1172.53,632.886]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1185.06,675.107]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1191.91,657.73]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1193.05,699.041]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[909.534,600.206]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[993.269,575.315]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1071.03,605.885]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1093.62,569.978]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1117.49,607.61]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1124.94,789.181]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1142.43,681.754]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1168.08,590.82]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1170.72,636.202]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1171.98,582.939]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1177.62,571.522]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1175.54,624.474]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1185.83,679.155]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1183.42,617.625]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1192.08,703.535]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1200.16,661.784]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[900.462,598.682]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[994.719,575.259]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1058.04,607.079]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1093.16,792.151]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1098.6,571.425]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1103.88,609.626]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1146.24,684.982]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1163.41,593.581]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1167.48,639.508]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1171.35,585.686]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1185.19,683.269]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1177.29,627.764]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1182.88,574.242]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1189.49,708.064]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1205.57,621.067]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1207.13,666.052]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[892.255,597.019]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[996.175,575.217]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1044.4,608.041]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1059.9,794.293]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1089.15,611.4]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1102.89,572.941]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1148.96,688.314]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1157.29,596.275]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1162.78,642.768]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1169.34,588.436]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1183.09,687.411]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1177.66,631.105]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1186.88,577.057]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1185.24,712.576]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1212.69,670.504]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1227.02,624.937]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[884.968,595.238]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[997.629,575.19]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[1025.63,795.554]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1030.26,608.765]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1073.43,612.916]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1106.47,574.521]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1149.74,598.882]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1150.56,691.735]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1156.61,645.961]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1165.92,591.17]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1179.51,691.564]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1176.64,634.481]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1179.31,717.043]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1189.55,579.955]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1216.78,675.126]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1247.68,629.242]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[878.664,593.348]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[990.816,795.846]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[999.076,575.175]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1015.74,609.231]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1056.86,614.143]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1109.29,576.152]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1140.77,601.365]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1148.98,649.041]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1150.97,695.204]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1161.07,593.858]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1174.38,695.677]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1174.15,637.853]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1171.68,721.394]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1190.82,582.912]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1219.29,679.872]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1267.44,633.986]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[873.383,591.367]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[955.959,795.145]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1000.51,575.172]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[1001,609.432]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1039.61,615.065]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1111.32,577.823]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1130.41,603.698]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1139.91,651.975]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1150.18,698.693]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1154.78,596.474]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1167.71,699.717]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1162.36,725.583]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1170.18,641.191]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1190.63,585.911]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1220.12,684.711]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1286.21,639.186]]
    },],[{
    name:"Juegos Infantiles",
    tipo:"Juegos Infantiles",
    verts:[[869.156,589.313]]
    },{
    name:"Lobby de Acceso",
    tipo:"Lobby de Acceso",
    verts:[[921.57,793.446]]
    },{
    name:"Sala de Lectura de Adultos",
    tipo:"Sala de Lectura de Adultos",
    verts:[[986.202,609.364]]
    },{
    name:"Zonas Húmedas",
    tipo:"Zonas Húmedas",
    verts:[[1001.93,575.178]]
    },{
    name:"Sala de Lectura de Niños",
    tipo:"Sala de Lectura de Niños",
    verts:[[1021.88,615.665]]
    },{
    name:"Coworking",
    tipo:"Coworking",
    verts:[[1112.52,579.522]]
    },{
    name:"Salón de Piñatas",
    tipo:"Salón de Piñatas",
    verts:[[1118.75,605.852]]
    },{
    name:"Sala de Videojuegos",
    tipo:"Sala de Videojuegos",
    verts:[[1129.46,654.726]]
    },{
    name:"Salón de Bienestar",
    tipo:"Salón de Bienestar",
    verts:[[1147.07,598.991]]
    },{
    name:"Gimnasio",
    tipo:"Gimnasio",
    verts:[[1159.49,703.644]]
    },{
    name:"Lavandería",
    tipo:"Lavandería",
    verts:[[1148.14,702.167]]
    },{
    name:"Pet Park",
    tipo:"Pet Park",
    verts:[[1151.4,729.555]]
    },{
    name:"Sala de Entretenimiento",
    tipo:"Sala de Entretenimiento",
    verts:[[1164.72,644.461]]
    },{
    name:"Salón de Yoga",
    tipo:"Salón de Yoga",
    verts:[[1188.93,588.927]]
    },{
    name:"BBQ",
    tipo:"BBQ",
    verts:[[1219.22,689.601]]
    },{
    name:"Lobby2",
    tipo:"Lobby2",
    verts:[[1303.88,644.875]]
    },],]

let amenitiess = []

interface Billboards{
    billboard: any
}

interface Props{
    amenity: any,
    angle: number,
    gallery: any,
    openGallery: any,
    show: boolean,
    leftOffset: number,
    selectAmenidad: string,
    zoom: number,
    topOffset: number
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    componentDidMount(){
        this.billboard = <div></div>
    }

    createBillboards = () => {
        
        if(this.props.selectAmenidad !== ''){
            
            if(Amenities[this.props.angle].length > 0){
                
                this.billboard = <div></div>
                for(let i = 0; i < Amenities[this.props.angle].length; i++)
                {
                    if(Amenities[this.props.angle][i].name === this.props.selectAmenidad){
  
                        
                        
                        /*this.setState(prevState => ({
                            pos: Amenities[this.props.angle][i].pos
                        }), 
                        () => {*/
                            this.billboard = <svg 
                            width={"100%"}
                            height={"100%"}
                            preserveAspectRatio="xMidYMid slice"
                            viewBox="0 0 1920 1080"
                            style={{
                                overflow: 'hidden',
                                pointerEvents: 'none',
                                position: 'absolute'
                            }}>
                                <g style={{
                                    pointerEvents: this.props.show ? 'visibleFill':'none'
                                }}
                                onClick = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                onTouchStart = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                >
                                    <circle 
                                        cx={Amenities[this.props.angle][i].verts[0][0]} 
                                        cy={Amenities[this.props.angle][i].verts[0][1]} 
                                        r="30" 
                                        style = {{
                                            fill:"rgba(90,89,92,.85)",
                                            stroke:"rgba(255,255,255,.85)",
                                            strokeWidth:1
                                        }}
                                    />
                                    <image 
                                        href={icons[this.props.amenity.Nombre + '2']}
                                        width="30"
                                        height="30"
                                        x={Amenities[this.props.angle][i].verts[0][0]-15}
                                        y={Amenities[this.props.angle][i].verts[0][1]-15}
                                        /*style={{
                                            position: 'absolute',
                                            left:this.state.pos[0],
                                            top:this.state.pos[1]
                                        }}*/
                                        
                                    ></image>
                                </g>
                                
                            </svg>;
                            
                        //})
                        break;
                    }                    
                }
            } 
            else
            {
                this.billboard = <div></div>
            }
            
        }
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
          imageSize = ['100%', '100%'];
          barOffset = 0;
        }
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 

        if(prevProps.amenity !== this.props.amenity){
            this.setState({transition:true})
            setTimeout(function(this: any){
                this.setState({
                    transition: false,
                })
                this.createBillboards();
                this.forceUpdate();   
            }.bind(this), 250)
        }
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();        
        }
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.billboard}
            </div>
            
        );
      
    }

}

export default Billboards